/**
 * Stable BFF catalog article codes (`/catalog/v1/bff/products`); numeric `id` differs by environment.
 */
export const MATTRESS_PRODUCT_CODE = '1122331';
export const FRAME_PRODUCT_CODE = '1122333';
export const RELAXATION_MASK_PRODUCT_CODE = '1122334';

/**
 * Cart / order lines use environment-specific catalog `id`. Resolve via
 * {@link findCatalogProductByCode} + {@link useResolvedCatalogProductIds}.
 */
export function matchesMattressProductId(
  id: string | undefined,
  mattressCatalogId: string | undefined,
): boolean {
  return Boolean(id && mattressCatalogId && id === mattressCatalogId);
}

export function matchesFrameProductId(
  id: string | undefined,
  frameCatalogId: string | undefined,
): boolean {
  return Boolean(id && frameCatalogId && id === frameCatalogId);
}

export function matchesRelaxationMaskProductId(
  id: string | undefined,
  maskCatalogId: string | undefined,
): boolean {
  return Boolean(id && maskCatalogId && id === maskCatalogId);
}

/**
 * BFF catalog subscription article codes (`/catalog/v1/bff/subscriptions`).
 * Cart / PUT payloads use the environment-specific catalog `id` resolved from these codes
 * (see catalog lookup helpers and `useResolvedCatalogProductIds`).
 */
export const YEARLY_SUBSCRIPTION_CODE = '1122339';
export const MONTHLY_SUBSCRIPTION_CODE = '1122337';
export const NONE_SUBSCRIPTION_PRODUCT_ID = 'none';

/** App subscription pricing grid article codes (`AppSubscriptionSection`). */
export const APP_SUBSCRIPTION_PRODUCT_CODES = {
  individual: {
    monthly: '1122337',
    yearly: '1124199',
    lifetime: '1124205',
  },
  duo: {
    monthly: '1124200',
    yearly: '1124201',
    lifetime: '1124206',
  },
  family: {
    monthly: '1124202',
    yearly: '1124203',
    lifetime: '1124207',
  },
} as const;

/** SKUs returned by catalog but not shown in the app subscription pricing grid. */
export const EXCLUDED_APP_SUBSCRIPTION_PRODUCT_CODES = new Set([
  YEARLY_SUBSCRIPTION_CODE,
  '1124204',
  '1124208',
  '1124209',
  '1124210',
]);

export const APP_SUBSCRIPTION_PURCHASABLE_PRODUCT_CODES = new Set(
  Object.values(APP_SUBSCRIPTION_PRODUCT_CODES).flatMap(plan =>
    Object.values(plan),
  ),
);
